'use strict';

// SP表示時は商品を2つ表示、それ以降は「もっと見る」ボタンで表示する
function productDisp() {
    $('.m-productList_more').each(function() {
        const $moreBtn = $(this).find('.btn');
        const $hidden = $(this).closest('.m-productList').find('.m-productList_item:gt(1)');
        if ($(this).css('display') === 'block') {
            $moreBtn.attr('aria-expanded', 'false');
            $hidden.hide();
        } else {
            $moreBtn.attr('aria-expanded', 'true');
            $hidden.show();
        }
    });
};

/**
 * Product list more for SP
 */
module.exports = function () {
    let lastWinW = $(window).width();
    $(window).on('load', function() {
        productDisp();
    });
    $(window).on('resize', function() {
        // 横幅が変わった場合のみ実行
        if(lastWinW !== $(window).width()) {
            productDisp();
            lastWinW = $(window).width();
        };
    });

    // もっと見る開閉
    $(document).on('click', '.m-productList_more .btn', function() {
        const $hidden = $(this).closest('.m-productList').find('.m-productList_item:gt(1)');
        let expanded = $(this).attr('aria-expanded');
        if (expanded === 'false') {
            $(this).attr('aria-expanded', 'true');
            $hidden.show();
        } else {
            $(this).attr('aria-expanded', 'false');
            $hidden.hide();
        }
    });

    const mo = new MutationObserver(function (mutations){
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length > 0) {
                productDisp();
            }
        });
    });
    const slotWrapperElements = $('[id^=cq_recomm_slot-]');
    Array.prototype.forEach.call(slotWrapperElements, function (slotWrapperElement) {
        mo.observe(slotWrapperElement, {
            childList: true,
            subtree: true
        });
    });
};
